import { Api } from 'utils';

class MembershipService {
  static get = async (params = {}) => Api.createResponse('app/membership/', params);
  // Cotización de solo lectura: los mismos montos que pay() va a cobrar (con el descuento de
  // un código promocional vigente, si aplica).
  static quote = async (params = {}) => Api.createResponse('app/membership/quote', params);
  static pay = async (params = {}) => Api.createResponse('app/membership/pay', params);
  static getBanks = async (params = {}) => Api.createResponse('app/membership/banks', params);
  static getUser = async (params = {}) => Api.createResponse('app/membership/user', params);
  static generateOtp = async (params = {}) =>
    Api.createResponse('app/membership/generate-otp', params);
  static getPlanUser = async (params = {}) =>
    Api.createResponse('app/membership/plan-user', params);

  static admin = {
    get: async (params?: any) => Api.createResponse('admin/memberships/', params),
    create: async (params?: any) => Api.createResponse('admin/memberships/create', params),
    update: async (params?: any) => Api.createResponse('admin/memberships/update', params),
    delete: async (params?: any) => Api.createResponse('admin/memberships/delete', params),
    getColors: async (params?: any) => Api.createResponse('admin/memberships/colors', params),
    getServices: async (params?: any) => Api.createResponse('admin/memberships/services', params),
  };
}

export default MembershipService;
